import React from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Copyright } from "@/_components";
export const DrawerFooter = () => {
  const { t } = useTranslation();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const countryUrl = countryCode === "AU" ? "au" : "com";
  return (
    <Grid
      container
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid>
        <Grid
          container
          style={{
            margin: "auto",
          }}
          sx={{
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Grid>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/terms-of-use/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                paddingRight: 15,
                paddingLeft: 15,
                color: "#1c355e",
                textDecoration: "none",
              }}
            >
              {t("policies.termsofUseLabel")}
            </Link>
          </Grid>
          <Grid>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/privacy-policy/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1c355e",
                 paddingRight: 15,
                textDecoration: "none",
              }}
            >
              {t("policies.privacyLabel")}
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid
          container
          sx={{
            flexDirection: "row",
          }}
        >
          <Grid>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/cookie-policy/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                paddingRight: 15,
                paddingLeft: 15,
                color: "#1c355e",
                textDecoration: "none",
              }}
            >
              {t("policies.cookiesLabel")}
            </Link>
          </Grid>
          <Grid>
            <Link
              color="inherit"
              href={`https://www.lifesafer.${countryUrl}/quality-policy/`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1c355e",
                textDecoration: "none",
              }}
            >
              {t("policies.qualityLabel")}
            </Link>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Copyright />
      </Grid>
    </Grid>
  );
};
